import React, { useEffect, useState } from 'react';
import { LoginState } from '../../types/LoginState';
import { useClubContext } from '../../hooks/ClubContext';
import { ClubLink } from '../../types/clubLinksTypes';
import { generateWWEvents } from '../../WWEvents';
import triggerSignupAndLoginOverlay from '../../helpers/triggerSignupAndLoginOverlay';
import AccountFlyout from './AccountFlyout';
import AccountIcon from './AccountIcon';
import { useHeaderContext } from 'Components/HeaderContext';

const Account = ({ isLoggedIn, isPartiallyLoggedIn }: LoginState): JSX.Element => {
    const { t } = useHeaderContext();
    const { links } = useClubContext();
    const [showFlyout, setShowFlyout] = useState(false);

    const handleClick = (evt: React.MouseEvent) => {
        if (!isLoggedIn && isPartiallyLoggedIn) {
            const WWEvents = generateWWEvents();
            evt.preventDefault();
            WWEvents.fire('SIGNUP_OVERLAY_OPEN', {
                isClosable: true,
            });
        }

        // todo we have different state for club alice partial login and club mf partial login. we need to unified them
        if (isPartiallyLoggedIn) {
            evt.preventDefault();
            // this is for club mf
            triggerSignupAndLoginOverlay({ redirectUrl: links[ClubLink.CUSTOMER_ACCOUNT].path });
        }
    };

    useEffect(() => {
        if (isLoggedIn === true || isPartiallyLoggedIn === true) {
            setShowFlyout(true);
        }
    }, [isLoggedIn, isPartiallyLoggedIn]);
    return showFlyout ? (
        <AccountFlyout onClickWhenLoginRequired={handleClick} />
    ) : (
        <AccountIcon
            data-testid="oww-header-account-icon"
            onClick={handleClick}
            href={links[ClubLink.CUSTOMER_ACCOUNT].path}
            ariaLabel={t('OwwHeader_My account')}
        />
    );
};

export default Account;
